/* Shows the first field error of a failed save (or its general message) and focuses that field. */
export function reportError(err, showToast, idPrefix) {
  const field = err.errors && Object.keys(err.errors)[0];
  showToast(field ? err.errors[field] : err.message, "error");
  if (field) {
    const input = document.getElementById(`${idPrefix}-${field}`);
    if (input) input.focus();
  }
}

/* New password + its confirmation, checked before the round trip. */
export const checkPasswords = (form) => {
  if (form.password.length < 6) return { password: "The password must be at least 6 characters" };
  if (form.password !== form.password_confirmation) return { password_confirmation: "The passwords don't match" };
  return null;
};
